import {
  GetFormsForPermissionsQuery,
  GetEndpointsForPermissionsQuery,
  GetFormsV2ForPermissionsQuery,
  GetManualTriggersQuery,
  GetTablesForPermissionsQuery,
  GetWorkspacesForPermissionsQuery,
} from '~/common/generated/apollo-operations'

export type PermissionsTabTable = GetTablesForPermissionsQuery['tables'][number]
export type PermissionsTabTableColumn = PermissionsTabTable['columns'][number]
export type PermissionsTabTableTab = PermissionsTabTable['tableTabs'][number]
export type PermissionsTabChildTable = PermissionsTabTable['childTables'][number]

export type PermissionsTabFormV1 = GetFormsForPermissionsQuery['forms'][number]
export type PermissionsTabFormV2 = GetFormsV2ForPermissionsQuery['allFormsV2'][number]

/** @deprecated Use PermissionsTabFormUnified instead */
export type PermissionsTabForm = PermissionsTabFormV1

export type PermissionsTabFormLinkedTable = NonNullable<
  PermissionsTabFormV1['pages'][number]['categories'][number]['lookupTable']
>

/** Unified form type that can represent either Form V1 or V2 */
export type PermissionsTabFormUnified =
  | (PermissionsTabFormV1 & { isFormsV2?: false })
  | (PermissionsTabFormV2 & { isFormsV2: true })

export type PermissionsTabWorkspace = GetWorkspacesForPermissionsQuery['workspaces'][number]
export type ManualTrigger = GetManualTriggersQuery['actionManualTriggers'][number]

/** An endpoint an app may call: internal ones are callable from workflows only, so never listed. */
export type PermissionsTabEndpoint = GetEndpointsForPermissionsQuery['endpoints'][number]

/**
 * An embed (dynamic app) no VIEW_WORKSPACE grant can reach: directly in a project or record
 * workspace, or in no workspace. `location` is that workspace's root object name (empty when
 * unnamed), or the "No workspace" label when unplaced.
 * Shown so admins can tell same-named apps apart.
 */
export type PermissionsTabEmbed = {
  id: string
  name: string
  location: string
}

export enum BasicPermissionType {
  view = 'view',
  edit = 'edit',
}

export enum FormPermissionType {
  submit = 'submit',
}

export enum EndpointPermissionType {
  call = 'call',
}
